import { BillingActionTypes } from '../constants/ApiConstants';


const initialState = {
  loading: false,
  master_data: [],
  allSecondaryPayer:null,
  claimMasterData: null,
  readyToBillClaims: [],
  claimServiceLines: [],
  readyToBillClaimData: {},
  edi837ForSecondary: null,
  ClaimData: {},
  PatientEncounterDetailsData: {},
  insuranceCompaniesList: [],
  patientList: [],
  claimsWithServiceLinesForPayerDetails: null,
  savedApplyPayments: null,
  downloadStatus: false,
  processedClaim: [],
  unmappedClaim: [],
  claimHistoryData: [],
  patientServiceLocations: null,
  serviceLineDetails: null,
  Autocomplete_MUI: null,
  EDI837Secondary: {},
  SubmittedMultipleClaims: null,
  ResubmittedMultipleClaims: null,
  loading_servicecodedetails: false,
  payerServiceCodeDetailsData: {},
  ParseEDI835Data: {},
  payerCptCodes: [],
  resubmitBatchClaim: null,
  saved_Notes: null,
  deleted_Notes: null,
  saved_bulkNote: null,
  bulk_update_WriteOffDate:null,
  batchClaimRenderingProvider_updated: null,
  ParseEVVData: {},
  processedEVVClaim: [],
  appliedPaymentDetails: [],
  appliedPaymentDeleted: {},
  ParseEDI999Data: {},
  oaAcknowledgementClaim: [],
  oaandpayerResponseClaim: [],
  batchClaimRateForServiceCodes_updated: null,
  paymentDetails: null,
  addedPaymentDetails: null,
  ledgerDetails: null,
  isCalledFromERAModule:false,
  claimIdFromERAModule:null,
  dosFromERAModule:null,
};

export default (state = initialState, { type, payload }) => {

  switch (type) {
  case BillingActionTypes.get_claims.REQUEST:
  case BillingActionTypes.get_AllClaimsWithServiceLines.REQUEST:
  case BillingActionTypes.get_claims_BySearchText.REQUEST:
  case BillingActionTypes.get_ClaimDetails_ByClaimId.REQUEST:
  case BillingActionTypes.get_PatientEncounterDetails_ByEncounterId.REQUEST:
  case BillingActionTypes.get_SubmitClaim_EDI837.REQUEST:
  case BillingActionTypes.get_SubmitBatchClaim_EDI837.REQUEST:
  case BillingActionTypes.get_SubmitClaimsForNonEDI.REQUEST:
  case BillingActionTypes.get_autocomplete_mui.REQUEST: // Material UI Autocomplete
  case BillingActionTypes.get_all_payer_cpt_codes_by_payer.REQUEST:
  case BillingActionTypes.get_ResubmitBatchClaim_EDI837.REQUEST:
  case BillingActionTypes.get_SubmitBatchClaim_EVV.REQUEST:
  case BillingActionTypes.get_AppliedPaymentDetails.REQUEST:    
    return {
      ...state,
      payerCptCodes: [],
      PatientEncounterDetailsData: {},
      loading: true,
    };

  case BillingActionTypes.get_master_data.REQUEST:
  case BillingActionTypes.get_ClaimServiceLines_ByClaimId.REQUEST:
  case BillingActionTypes.delete_ServiceCode_FromClaim.REQUEST:
  case BillingActionTypes.update_Claim_Detials.REQUEST:
  case BillingActionTypes.delete_Claim.REQUEST:
  case BillingActionTypes.delete_BatchAppliedPayments.REQUEST:    
    return {
      ...state,
      readyToBillClaimData: null,
      loading: true,
    };
  case BillingActionTypes.get_ResubmitClaim.REQUEST:
  case BillingActionTypes.get_EDI837_Batch_Claim_secondary.REQUEST:
  case BillingActionTypes.get_PayerByPatientId.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case BillingActionTypes.get_patient.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case BillingActionTypes.get_Paper_Claim_secondary.REQUEST:
    return {
      ...state,
      loading: true,
      downloadStatus: false,
    };
  case BillingActionTypes.get_EDI837_secondary.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case BillingActionTypes.get_EDI837_secondary.SUCCESS:
    return {
      ...state,
      EDI837Secondary: payload,
      loading: false,
    };
  case BillingActionTypes.get_Paper_Claim_secondary.SUCCESS:
    return {
      ...state,
      loading: false,
      downloadStatus: true,
    };
  case BillingActionTypes.get_EDI837_Batch_Claim_secondary.SUCCESS:
    return {
      ...state,
      edi837ForSecondary: payload,
      loading: false,
    };
  case BillingActionTypes.get_ResubmitClaim.SUCCESS:
    return {
      ...state,
      reSubmitClaim: payload,
      loading: false,
    };
  case BillingActionTypes.get_patient.SUCCESS:
    return {
      ...state,
      patientList: payload,
      loading: false,
    };
  case BillingActionTypes.get_patient_guarantor.REQUEST:
    return {
      ...state,
    };
  case BillingActionTypes.get_patient_guarantor.SUCCESS:
    return {
      ...state,
      guarantorList: payload,
      loading: false,
    };
  case BillingActionTypes.get_processed_claim.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case BillingActionTypes.get_claim_history.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case BillingActionTypes.get_claim_history.SUCCESS:
    return {
      ...state,
      claimHistoryData: payload,
      loading: false,
    };
  case BillingActionTypes.get_processed_claim.SUCCESS:
    return {
      ...state,
      processedClaim: payload,
      loading: false,
    };
  case BillingActionTypes.get_unmapped_claim.REQUEST:
    return {
      ...state,
      loading: true,
    };
    case BillingActionTypes.get_unmapped_claim.SUCCESS:
    return {
      ...state,
      unmappedClaim: payload,
      loading: false,
    };
  case BillingActionTypes.get_master_data.SUCCESS:
    return {
      ...state,
      master_data: payload,
      loading: false,
    };
  case BillingActionTypes.get_claim_master_data.REQUEST:
    return {
      ...state,
      claimMasterData: null,
    }
    case BillingActionTypes.getAllSecondaryPayer.SUCCESS:
      return {
        ...state,
        allSecondaryPayer: payload,
        loading: false,
      };
      
    case BillingActionTypes.getAllSecondaryPayer.REQUEST:
      return {
        ...state
      }  
  case BillingActionTypes.get_claim_master_data.SUCCESS:
    return {
      ...state,
      claimMasterData: payload,
    }
  case BillingActionTypes.get_claims.SUCCESS:
    return {
      ...state,
      readyToBillClaims: payload,
      loading: false,
    };
  case BillingActionTypes.get_AllClaimsWithServiceLines.SUCCESS:
    return {
      ...state,
      readyToBillClaims: payload,
      loading: false,
    };
  case BillingActionTypes.get_ClaimServiceLines_ByClaimId.SUCCESS:
    return {
      ...state,
      claimServiceLines: payload,
      loading: false,
    };
  case BillingActionTypes.get_ClaimDetails_ByClaimId.SUCCESS:
    return {
      ...state,
      claimData: payload,
      loading: false,
    };
  case BillingActionTypes.get_claims_BySearchText.SUCCESS:
    return {
      ...state,
      readyToBillClaims: payload,
      loading: false,
    };
  case BillingActionTypes.Post_ServiceCode_ForClaim.REQUEST:
    return {
      ...state,
      readyToBillClaimData: null,
      loading: true,
    };
  case BillingActionTypes.Post_ServiceCode_ForClaim.SUCCESS:
    return {
      ...state,
      readyToBillClaimData: payload,
      loading: false,
    };
  case BillingActionTypes.delete_ServiceCode_FromClaim.SUCCESS:
    return {
      ...state,
      readyToBillClaimData: payload,
      loading: false,
    };
  case BillingActionTypes.update_Claim_Detials.SUCCESS:
    return {
      ...state,
      readyToBillClaimData: payload,
      loading: false,
    };
  case BillingActionTypes.get_PatientEncounterDetails_ByEncounterId.SUCCESS:
    return {
      ...state,
      PatientEncounterDetailsData: payload,
      loading: false,
    };
  case BillingActionTypes.get_PayerByPatientId.SUCCESS:
    return {
      ...state,
      insuranceCompaniesList: payload,
      loading: false,
    };
  case BillingActionTypes.get_SubmitClaim.REQUEST:
    return {
      ...state,
      loading: true,
      downloadStatus: false,
    };
  case BillingActionTypes.get_SubmitClaim.SUCCESS:
    return {
      ...state,
      loading: false,
      downloadStatus: true,
    };
  case BillingActionTypes.get_AllClaimsWithServiceLinesForPayer.REQUEST:
    return {
      ...state,
      loading: true,
      savedApplyPayments: null,
      claimsWithServiceLinesForPayerDetails: null,
    };
  case BillingActionTypes.get_AllClaimsWithServiceLinesForPayer.SUCCESS:
    return {
      ...state,
      loading: false,
      savedApplyPayments: null,
      claimsWithServiceLinesForPayerDetails: payload,
    };
  case BillingActionTypes.post_apply_payment.REQUEST:
    return {
      ...state,
      loading: true,
      savedApplyPayments: null,
    };
  case BillingActionTypes.post_apply_payment.SUCCESS:
    return {
      ...state,
      loading: false,
      savedApplyPayments: payload,
    };
  case BillingActionTypes.post_apply_payment.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case BillingActionTypes.get_patient_serviceLocations.REQUEST:
    return {
      ...state,
      loading: true,
      patientServiceLocations: null,
    };
  case BillingActionTypes.get_patient_serviceLocations.SUCCESS:
    return {
      ...state,
      loading: false,
      patientServiceLocations: payload,
    };
  case BillingActionTypes.get_claimServiceLineDetails.REQUEST:
    return {
      ...state,
      loading: true,
      serviceLineDetails: null,
    };
  case BillingActionTypes.get_claimServiceLineDetails.SUCCESS:
    return {
      ...state,
      loading: false,
      serviceLineDetails: payload,
    };
  case BillingActionTypes.get_SubmitClaim_EDI837.SUCCESS:
  case BillingActionTypes.get_SubmitBatchClaim_EDI837.SUCCESS:
  case BillingActionTypes.get_SubmitClaimsForNonEDI.SUCCESS:
  case BillingActionTypes.get_SubmitBatchClaim_EVV.SUCCESS:    
    return {
      ...state,
      SubmittedMultipleClaims: payload,
      loading: false,
    };
  case BillingActionTypes.get_ResubmitBatchClaim_EDI837.SUCCESS:
    return {
      ...state,
      ResubmittedMultipleClaims: payload,
      loading: false,
    };
  case BillingActionTypes.get_autocomplete_mui.SUCCESS:
    return {
      ...state,
      loading: false,
      Autocomplete_MUI: payload,
    };
  case BillingActionTypes.get_all_payer_cpt_codes_by_payer.SUCCESS:
    return {
      ...state,
      loading: false,
      payerCptCodes: payload,
    };
  case BillingActionTypes.get_payer_servicecode_by_Id.REQUEST:
    return {
      ...state,
      loading_servicecodedetails: true,
      payerServiceCodeDetailsData: null,
    };
  case BillingActionTypes.get_payer_servicecode_by_Id.SUCCESS:
    return {
      ...state,
      loading_servicecodedetails: false,
      payerServiceCodeDetailsData: payload,
    };
  case BillingActionTypes.delete_Claim.SUCCESS:
    return {
      ...state,
      readyToBillClaimData: payload,
      loading: false,
    };
  case BillingActionTypes.get_ParseEDI835_FromClearingHouse.REQUEST:
    return {
      ...state,
      //loading: true,
      ParseEDI835Data: null,
    };
  case BillingActionTypes.get_ParseEDI835_FromClearingHouse.SUCCESS:
    return {
      ...state,
      loading: false,
      ParseEDI835Data: payload,
    };
    case BillingActionTypes.get_ParseEDI835_FromClearingHouse_MasterAccount.REQUEST:
      return {
        ...state,
        //loading: true,
        ParseEDI835Data: null,
      };
    case BillingActionTypes.get_ParseEDI835_FromClearingHouse_MasterAccount.SUCCESS:
      return {
        ...state,
        loading: false,
        ParseEDI835Data: payload,
      };
  case BillingActionTypes.post_ResubmitBatchClaim_EDI837.REQUEST:
    return {
      ...state,
      loading: true,
      resubmitBatchClaim: null,
    };
  case BillingActionTypes.post_ResubmitBatchClaim_EDI837.SUCCESS:
    return {
      ...state,
      loading: false,
      resubmitBatchClaim: payload,
    };
  case BillingActionTypes.get_SubmitBatchClaim.REQUEST:
    return {
      ...state,
      loading: true,
      downloadStatus: false,
    };
  case BillingActionTypes.get_SubmitBatchClaim.SUCCESS:
    return {
      ...state,
      loading: false,
      downloadStatus: true,
    };
  case BillingActionTypes.get_SubmitBatchClaim_SecondaryPayer.REQUEST:
    return {
      ...state,
      loading: true,
      downloadStatus: false,
    };
  case BillingActionTypes.get_SubmitBatchClaim_SecondaryPayer.SUCCESS:
    return {
      ...state,
      loading: false,
      downloadStatus: true,
    };
  case BillingActionTypes.Post_Claim_Internal_Notes.REQUEST:
    return {
      ...state,
      loading: true,     
      saved_Notes: null, 
    };
  case BillingActionTypes.Post_Claim_Internal_Notes.SUCCESS:
    return {
      ...state,
      loading: false,  
      saved_Notes: payload,    
      };
  case BillingActionTypes.Get_Claim_Internal_Notes.REQUEST:
    return {
      ...state,      
      loading: true,
      ClaimInternalNotes: null,
    };
  case BillingActionTypes.Get_Claim_Internal_Notes.SUCCESS:
    return {
      ...state,
      ClaimInternalNotes: payload,
      loading: false,
    };
  case BillingActionTypes.Delete_Claim_Internal_Notes.REQUEST:
    return {
      ...state,
      loading: true,   
      deleted_Notes: null,   
    };
  case BillingActionTypes.Delete_Claim_Internal_Notes.SUCCESS:
    return {
      ...state,
      loading: false,      
      deleted_Notes: payload,
      };
    case BillingActionTypes.change_Claim_Status.REQUEST:
      return {
        ...state,
        loading: true,
        changeClaimsStatus: null
      };
    case BillingActionTypes.change_Claim_Status.SUCCESS:
      return {
        ...state,
        loading: false,
        changeClaimsStatus: payload
      };
      case BillingActionTypes.save_NotesBulk.REQUEST:
      return {
        ...state,
        loading: true,
        saved_bulkNote: null
      };
    case BillingActionTypes.save_NotesBulk.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_bulkNote: payload
      };
      case BillingActionTypes.bulkUpdateWriteOffDate.REQUEST:
      return {
        ...state,
        loading: true,
        bulk_update_WriteOffDate: null
      };
    case BillingActionTypes.bulkUpdateWriteOffDate.SUCCESS:
      return {
        ...state,
        loading: false,
        bulk_update_WriteOffDate: payload
      };
    case BillingActionTypes.patch_UpdateBatchCLaimRenderingProvider_Claim.REQUEST:
      return {
        ...state,
        loading: true,
        batchClaimRenderingProvider_updated: null,
      };
    case BillingActionTypes.patch_UpdateBatchCLaimRenderingProvider_Claim.SUCCESS:
      return {
        ...state,
        loading: false,
        batchClaimRenderingProvider_updated: payload,
      };
    case BillingActionTypes.get_download_batch_EDI.REQUEST: // Uploaded document download
      return {
        ...state,
        loading: true,
      };
    case BillingActionTypes.get_download_batch_EDI.SUCCESS: // uploaded document download
      return {
        ...state,
        loading: false,
        SubmittedMultipleClaims: payload,
      };
    case BillingActionTypes.get_ParseEVVResponse_FromTellus.REQUEST:
      return {
        ...state,
        //loading: true,
        ParseEVVData: null,
      };
    case BillingActionTypes.get_ParseEVVResponse_FromTellus.SUCCESS:
      return {
        ...state,
        loading: false,
        ParseEVVData: payload,
      };
    case BillingActionTypes.get_processed_evvclaim.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case BillingActionTypes.get_processed_evvclaim.SUCCESS:
      return {
        ...state,
        processedEVVClaim: payload,
        loading: false,
      };
    case BillingActionTypes.get_AppliedPaymentDetails.SUCCESS:
      return {
        ...state,
        appliedPaymentDetails: payload,
        loading: false,
      };
    case BillingActionTypes.delete_BatchAppliedPayments.REQUEST:    
      return {
        ...state,
        appliedPaymentDeleted: null,
        loading: true,
      };
    case BillingActionTypes.delete_BatchAppliedPayments.SUCCESS:
      return {
        ...state,
        appliedPaymentDeleted: payload,
        loading: false,
      };
    case BillingActionTypes.get_ParseEDI999_FromClearingHouse.REQUEST:
      return {
        ...state,
        //loading: true,
        ParseEDI999Data: null,
      };
    case BillingActionTypes.get_ParseEDI999_FromClearingHouse.SUCCESS:
      return {
        ...state,
        loading: false,
        ParseEDI999Data: payload,
      };
    case BillingActionTypes.get_oaacknowledgement_claim.REQUEST:
      return {
        ...state,
        loading: true,
      };
   case BillingActionTypes.get_oaacknowledgement_claim.SUCCESS:
      return {
        ...state,
        oaAcknowledgementClaim: payload,
        loading: false,
      };
    case BillingActionTypes.get_oaandpayerresponse_claim.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case BillingActionTypes.get_oaandpayerresponse_claim.SUCCESS:
      return {
        ...state,
        oaandpayerResponseClaim: payload,
        loading: false,
      };
    case BillingActionTypes.patch_UpdateBatchRateForServiceCodes_Claim.REQUEST:
      return {
        ...state,
        loading: true,
        batchClaimRateForServiceCodes_updated: null,
      };
    case BillingActionTypes.patch_UpdateBatchRateForServiceCodes_Claim.SUCCESS:
      return {
        ...state,
        loading: false,
        batchClaimRateForServiceCodes_updated: payload,
      };
    case BillingActionTypes.post_batchPaymentDetails.REQUEST:
      return {
        ...state,
        loading: true,
        addedPaymentDetails: null,
      };
    case BillingActionTypes.post_batchPaymentDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        addedPaymentDetails: payload,
      };
    case BillingActionTypes.get_paymentDetails.REQUEST:
      return {
        ...state,
        loading: true,
        paymentDetails: payload,
      };
    case BillingActionTypes.get_paymentDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        paymentDetails: payload,
      };
    case BillingActionTypes.post_paymentDetails.REQUEST:
    return {
      ...state,
      loading: true,
      addedPaymentDetails: null,
    };
    case BillingActionTypes.post_paymentDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        addedPaymentDetails: payload,
      };
      case BillingActionTypes.get_ledgerDetails.REQUEST:
      return {
        ...state,
        loading: true,
        ledgerDetails: null,
      };
    case BillingActionTypes.get_ledgerDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        ledgerDetails: payload,
      };
    case BillingActionTypes.get_Iscalled_FromERAMoule_Flag.SUCCESS:
      return {
        ...state,
        isCalledFromERAModule: payload.flag,
        claimIdFromERAModule:payload.batchId,
        dosFromERAModule:payload.dos
      };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/reducers/ManageClaimReducer.js